import React from 'react';
import SliderAdapter from '@/components/common/Forms/SliderQuestion/SliderAdapter';
import { noAnswerProvided } from '@/components/staffer/Grading/utils';
import { StudentAnswerProps } from '../types';

const SliderQuestionStudentAnswer = ({ question, questionAnswer }: StudentAnswerProps) => {
  if (!questionAnswer?.answer) return noAnswerProvided();

  const selectedIndex = parseInt(questionAnswer.answer, 10);
  if (isNaN(selectedIndex)) return noAnswerProvided();
  const marks = question.answer_choices.map((label, index) => ({ label, value: index }));

  return (
    <div className="tw-w-full tw-box-border tw-px-8 tw-flex tw-justify-center">
      <SliderAdapter
        ariaLabelledBy={`slider-question-${question.id}`}
        defaultValue={selectedIndex}
        disabled
        input={{ name: 'answer', value: questionAnswer.answer }}
        marks={marks}
        max={question.answer_choices.length - 1}
        meta={{ dirty: false }}
        min={0}
        previewOnly={false}
        step={null}
        valueLabelDisplay="off"
      />
    </div>
  );
};

export default SliderQuestionStudentAnswer;
